var React = require('react');

function Loading (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.74 18.44c-.85.37-1.78.56-2.74.56v3c1.4 0 2.72-.28 3.92-.8l-1.18-2.76zm-6.47 2.84c-1.26-.5-2.4-1.26-3.34-2.2l2.12-2.13c.67.67 1.46 1.2 2.34 1.55l-1.16 2.78zm-2.7-6.52c-.4-.86-.57-1.78-.57-2.74H2c0 1.4.28 2.72.8 3.92l2.76-1.18zM2.7 8.3c.5-1.27 1.26-2.4 2.2-3.35l2.13 2.12c-.67.67-1.2 1.46-1.55 2.34L2.72 8.3zm6.56-2.74C10.12 5.2 11.04 5 12 5V2c-1.4 0-2.72.28-3.92.8l1.18 2.76zm6.47-2.84c1.26.5 2.4 1.26 3.34 2.2l-2.13 2.13c-.67-.67-1.46-1.2-2.34-1.55l1.12-2.78zm2.7 6.56c.36.86.55 1.78.55 2.74h3c0-1.4-.3-2.72-.8-3.92l-2.76 1.18zm2.83 6.47c-.5 1.26-1.26 2.4-2.2 3.34l-2.13-2.16c.67-.67 1.2-1.46 1.55-2.34l2.78 1.13z","fillRule":"evenodd"}));
}

Loading.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Loading;

Loading.default = Loading;
